import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalRoot,
  UIHeading2,
  UIText1,
} from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import sadImage from './assets/sad.png';
import * as styles from './NewbuildingBrokerFallbackModal.css';

interface INewbuildingBrokerFallbackModalProps {
  imageUrl?: string;
  title: string;
  description: string;
  buttonText: string;
  loading: boolean;
  onClose: () => void;
  onRetry: () => void;
}

/**
 * Модалка отображается, когда не удалось загрузить микрофронт.
 */
export const NewbuildingBrokerFallbackModal: React.FC<INewbuildingBrokerFallbackModalProps> = ({
  imageUrl,
  title,
  description,
  buttonText,
  loading,
  onClose,
  onRetry,
}) => {
  const handleOpenChange = React.useCallback(
    (nextOpen: boolean) => {
      if (!nextOpen) {
        onClose();
      }
    },
    [onClose],
  );

  const contentWrapperClass = `${styles['content-wrapper']} ${loading ? styles['semi-transparent'] : ''}`;

  return (
    <ModalRoot open onOpenChange={handleOpenChange}>
      <ModalContent size="S">
        <ModalCloseButton title="Закрыть" size="XS" theme="fill_light" icon={<IconActionClose12 />} />
        <ModalBody>
          <div className={contentWrapperClass} data-testid="NewbuildingBrokerFallbackModalContent">
            <div
              className={styles['image']}
              style={{ '--image-url': `url(${imageUrl ?? sadImage})` } as React.CSSProperties}
            />
            <div className={styles['text-wrapper']}>
              <UIHeading2 textAlign="center">{title}</UIHeading2>
              <UIText1 textAlign="center" color="text-secondary-default">
                {description}
              </UIText1>
            </div>
          </div>
        </ModalBody>
        <ModalFooter sticky={false}>
          <div className={styles['button-wrapper']}>
            <Button loading={loading} fullWidth onClick={onRetry}>
              {buttonText}
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </ModalRoot>
  );
};
